import { library, dom } from '@fortawesome/fontawesome-svg-core';
import { faCheck, faSquare, faAngleRight, faAngleDoubleRight, faAngleDoubleDown} from '@fortawesome/free-solid-svg-icons';
import { faXTwitter, faFacebook, faTwitch, faInstagram, faXbox, faPlaystation, faYoutube, faTiktok } from '@fortawesome/free-brands-svg-icons';
import "../scss/main.scss";

import $ from 'jquery';
window.$ = $;
window.jQuery = $;
var jQuery = $;

import {wg_modal} from './wg_ui/wg_modal.js';
window.wg_modal = wg_modal;

import {wg_ui} from './wg_ui/wg_ui.js';
window.wg_ui = wg_ui;

import {wg_errors} from './wg_ui/wg_errors.js';
window.wg_errors = wg_errors;

import {SVGInjector} from './plugins/svg-injector/svg-injector.js';
window.SVGInjector = SVGInjector;

import _ from 'underscore';
window._ = _;

import Backbone from 'backbone';
window.Backbone = Backbone;

import Cookies from 'js-cookie';
window.Cookies = Cookies;

require('./browser_detection_module.js');
require('./tooltip.js');
require('./category_menu.js');
require('./plugins/jquery.lazyload/jquery.lazyload.js');
require('./plugins/modernizr/modernizr.js');
require('./plugins/jquery.tablesorter/jquery.tablesorter.js');
require('./svg_autosize.js');
require('./wgsdk.js');
require('./wgsdk.forms.js');
require('./ajax_info.js');
require('js-cookie');
require('./wginternal/jsbase.js');
require('./wginternal/oid.js');

import {autoFocusTextBox} from './util.js';
window.autoFocusTextBox = autoFocusTextBox;

import {portal_base_onload_handler, injectSVGs, bindCommonMenuEvents} from './portal_base.js';
window.portal_base_onload_handler = portal_base_onload_handler;
window.injectSVGs = injectSVGs;
window.bindCommonMenuEvents = bindCommonMenuEvents;

library.add(faCheck, faSquare, faAngleRight, faAngleDoubleRight,
  faAngleDoubleDown, faXTwitter, faFacebook, faTwitch, faInstagram, faXbox, faPlaystation, faYoutube, faTiktok);
dom.watch()

export {$, jQuery, injectSVGs, autoFocusTextBox};
